import { BulbOutlined, DeleteOutlined, ToolOutlined, FileExcelOutlined, DatabaseOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input, Space, Table, Tooltip } from 'antd'
import moment from 'moment'
import * as React from 'react'
import { Movimento, SorgenteType, TipoCategoriaIns } from '../../models/RaccoltaDatiModels'
import { ButtonEditInline } from '../shared/ButtonEditInline'
import { formatEuro } from '../shared/CurrencyFormat'

const { Column } = Table




interface TableUsciteProps {
    uscite: Array<Movimento>
    onEditMovimento?: (record: Movimento) => void
    onDeleteMovimento?: (record: Movimento) => void
}

export class TableUscite extends React.Component<TableUsciteProps, { searchText: '', searchedColumn: '', }>
{
    constructor(props) {
        super(props)
    }

    getColumn = () => {
        if (this.props.onDeleteMovimento == null) return
        return (
            <Column title="" dataIndex="Id" render={(_, record: Movimento) =>
                <Button type="primary" key="delete-mov-cc" icon={<DeleteOutlined />} size="small" onClick={() => this.props.onDeleteMovimento(record)} />
            } />
        )
    }

    renderCategoria = (value: string, record: Movimento) => {
        if (this.props.onEditMovimento == null) return <>{value}</>

        return (
            <ButtonEditInline
                title="Clicca per modificare il valore"
                onClick={() => this.props.onEditMovimento(record)}>&nbsp;{value}</ButtonEditInline>
        )
    }

    renderTipoCategoria = (value: TipoCategoriaIns, record: Movimento) => {

        if (value == TipoCategoriaIns.Manual) return <Tooltip title="Inserimento manuale"><ToolOutlined style={{color:"grey"}} /></Tooltip>;
        return <Tooltip title="Inserimento automatico"><BulbOutlined style={{ color: "green" }}/></Tooltip>

    }

    renderTipoSorgente = (value: SorgenteType, record: Movimento) => {

        if (value == SorgenteType.Excel) return <Tooltip title="Import da Excel"><FileExcelOutlined style={{ color: "green" }} /></Tooltip>;
        return <Tooltip title="Inserimento da provider"><DatabaseOutlined style={{ color: "gray" }} /></Tooltip>

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Cerca
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Resetta
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filtra
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#f5222d' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        //onFilterDropdownVisibleChange: visible => {
        //    if (visible) {
        //        setTimeout(() => this.searchInput.select(), 100);
        //    }
        //},
        //render: text =>
        //    this.state.searchedColumn === dataIndex ? (
        //        <Highlighter
        //            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        //            searchWords={[this.state.searchText]}
        //            autoEscape
        //            textToHighlight={text ? text.toString() : ''}
        //        />
        //    ) : (
        //        text
        //    ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    render() {




        return (
            <>
                <h3>Uscite conti correnti</h3>
                <Table
                    dataSource={this.props.uscite}
                    rowKey={it => it.Id}>
                    {this.getColumn()}
                    <Column title="Data" dataIndex="Data" render={(value: Date) => moment(value).format('LL')} />
                    <Column title="Descrizione" dataIndex="Descrizione"
                        {...this.getColumnSearchProps('Descrizione')}
                    />
                    <Column title="Importo" dataIndex="Importo" render={(value: number) => formatEuro(value)} />
                    <Column title="Conto corrente" dataIndex="ContoCorrente"
                        {...this.getColumnSearchProps('ContoCorrente')}
                    />
                    <Column title="Categoria" dataIndex="Categoria"
                        filters={[{ text: "Nessuna categoria", value: null }]}
                        onFilter={(filterValue, record: Movimento) => record.Categorie.findIndex(e => e == filterValue) > -1}
                        render={(value: string, record: Movimento) => this.renderCategoria(value, record)} />
                    <Column title="Sorgente" dataIndex="Sorgente"
                        filters={[{ text: "Excel", value: 0 }, { text: "Provider", value: 1 }]}
                        onFilter={(filterValue, record: Movimento) => record.Sorgente == filterValue}
                        render={(value: SorgenteType, record: Movimento) => this.renderTipoSorgente(value, record)} />
                    <Column title=""
                        dataIndex="TipoInserimentoCategoria"
                        filters={[{ text: "Manuale", value: 0 }, { text: "Automatiche", value: 1 }]}
                        onFilter={(filterValue, record: Movimento) => record.TipoInserimentoCategoria == filterValue  }
                        render={(value: TipoCategoriaIns, record: Movimento) => this.renderTipoCategoria(value, record)} />
                    <Column title="Tipo di costo" dataIndex="TipoCosto" />
                </Table>
            </>
        )
    }
    
}